<template>
  <div class="tabsContent">
    <div slot="tip" class="top-title">
      设备运维
    </div>
<!--    <div class="search-blank" >-->
<!--      <span class="bc-sp">{{ allchange.deviceModel }}：</span>-->
<!--      <el-select style="width: 170px;" filterable  v-model="terminalTypeName" :placeholder=allchange.PleaseSelect>-->
<!--        <el-option-->
<!--          v-for="item in deviceOption"-->
<!--          :key="item.value"-->
<!--          :label="item.label"-->
<!--          :value="item.value">-->

<!--        </el-option>-->
<!--      </el-select>-->
<!--      <span class="bc-sp">{{ allchange.enableState }}：</span>-->
<!--      <el-select style="width: 100px;"  v-model="enableStatus" :placeholder=allchange.PleaseSelect>-->
<!--        <el-option-->
<!--          key="1"-->
<!--          :label=allchange.all-->
<!--          value="">-->
<!--        </el-option>-->
<!--        <el-option-->
<!--          key="1"-->
<!--          :label=allchange.enable-->
<!--          :value="1">-->
<!--        </el-option>-->
<!--        <el-option-->
<!--          key="0"-->
<!--          :label=allchange.deactivate-->
<!--          :value="0">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--      <span class="bc-sp">{{ allchange.connectState }}：</span>-->
<!--      <el-select style="width: 100px;"  v-model="connectStatus" :placeholder=allchange.PleaseSelect>-->
<!--        <el-option-->
<!--          key="1"-->
<!--          :label=allchange.all-->
<!--          value="">-->
<!--        </el-option>-->
<!--        <el-option-->
<!--          key="1"-->
<!--          :label=allchange.connected-->
<!--          :value="1">-->
<!--        </el-option>-->
<!--        <el-option-->
<!--          key="0"-->
<!--          :label=allchange.unconnect-->
<!--          :value="0">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--      <span class="bc-sp">{{ allchange.onlineState }}：</span>-->
<!--      <el-select style="width: 100px;"  v-model="onlineStatus" :placeholder=allchange.PleaseSelect>-->
<!--        <el-option-->
<!--          key="1"-->
<!--          :label=allchange.all-->
<!--          value="">-->
<!--        </el-option>-->
<!--        <el-option-->
<!--          key="1"-->
<!--          :label=allchange.online-->
<!--          :value="1">-->
<!--        </el-option>-->
<!--        <el-option-->
<!--          key="0"-->
<!--          :label=allchange.offline-->
<!--          :value="0">-->
<!--        </el-option>-->
<!--      </el-select>-->

<!--&lt;!&ndash;      <span class="bc-sp">{{ allchange.AffiliatedUnit }}：</span>&ndash;&gt;-->
<!--&lt;!&ndash;        <el-cascader&ndash;&gt;-->
<!--&lt;!&ndash;          style="width: 170px;"&ndash;&gt;-->
<!--&lt;!&ndash;          v-model="deptName"&ndash;&gt;-->
<!--&lt;!&ndash;          :options="DeptList"&ndash;&gt;-->
<!--&lt;!&ndash;          :props="{ expandTrigger: 'hover',value:'deptName',label:'deptName' }"&ndash;&gt;-->
<!--&lt;!&ndash;         ></el-cascader>&ndash;&gt;-->

<!--      <span style="display: inline-block;">-->
<!--      <span class="bc-sp">{{ allchange.deviceName }}：</span>-->
<!--      <el-input-->
<!--        :placeholder=allchange.inputDevicename-->
<!--        style="margin: 10px 0;width: 150px;"-->
<!--        prefix-icon="el-icon-suitcase"-->
<!--        v-model="terminalName">-->

<!--      </el-input>-->
<!--</span>-->
<!--      <span style="display: inline-block;">-->
<!--      <span class="bc-sp">{{ allchange.deviceImei }}：</span>-->
<!--      <el-input-->
<!--        :placeholder=allchange.inputdeviceImei-->
<!--        style="margin: 10px 0;width: 150px;"-->
<!--        prefix-icon="el-icon-suitcase"-->
<!--        v-model="imei">-->
<!--      </el-input>-->
<!--      </span>-->
<!--      <span class="search-btn" @click="getTableData()">{{ allchange.query }}</span>-->
<!--    </div>-->
    <div class="query">
      <div class="query__filter">
        <span class="font">设备型号</span>
        <span>
              <el-select
                v-model="terminalTypeName"
                placeholder="请选择"
                style="width: 180px"
                size="large"
              >
                <el-option
                  v-for="item in deviceOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
        <span class="font">启用状态</span>
        <span>
              <el-select
                size="large"
                v-model="enableStatus"
                placeholder="请选择"
                style="width: 100px"
              >
                <el-option
                  v-for="item in enableOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
        <span class="font">连接状态</span>
        <span>
              <el-select
                v-model="connectStatus"
                placeholder="请选择"
                style="width: 100px"
                size="large"
              >
                <el-option
                  v-for="item in connectOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option> </el-select
              ></span>
        <span class="font">在线状态</span>
        <span>
              <el-select
                v-model="onlineStatus"
                placeholder="请选择"
                style="width: 100px"
                size="large"
              >
                <el-option
                  v-for="item in onlineOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
        <span class="font">设备名称</span>
        <span>
              <el-input
                placeholder="请输入设备名称"
                size="large"
                style="width: 160px"
                v-model="terminalName"
              />
            </span>
        <span class="font">设备imel</span>
        <span>
              <el-input
                placeholder="请输入设备imel"
                size="large"
                style="width: 160px"
                v-model="imei"
              />
            </span>
      </div>
      <div class="query__button">

        <el-button @click="refresh">重置</el-button>
      </div>
    </div>
    <div class="main-con"  :element-loading-text=allchange.loading>

      <div class="tree-Table">
        <div class="tree">
          <el-tree
            ref="tree"
            :highlight-current="true"
            default-expand-all
            :data="treeData"
            :props="defaultProps"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
        <div class="tableList">
          <el-table
            :cell-style="rowClass"
            :header-cell-style="headClass"
            ref="multipleTable"
            :data="tableData"
            row-key="imei"
            tooltip-effect="dark"
            height="560"
            style="width:100%;"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            @selection-change="handleSelectionChange">
            <el-table-column
              prop="terminalName"
              :label=allchange.deviceName
              show-overflow-tooltip
              width="180px"
            >
            </el-table-column>
            <el-table-column
              prop="imei"
              :label=allchange.deviceImei
              show-overflow-tooltip
              width="180px"
            >

            </el-table-column>
            <el-table-column
              prop="typeAlias"

              :label=allchange.deviceModel
              show-overflow-tooltip
              width="80px"
            >
            </el-table-column>
            <el-table-column
              prop="circuitNum"
              show-overflow-tooltip
              :label=allchange.circusNumber
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="circuitTypeName"
              :label=allchange.circusModel
            >
            </el-table-column>
            <el-table-column
              prop="deptName"
              show-overflow-tooltip
              width="180px"
              :label=allchange.AffiliatedUnit
            >
            </el-table-column>
            <el-table-column
              prop="addr485"
              show-overflow-tooltip
              :label=allchange.position
            >
            </el-table-column>
            <el-table-column
              prop="enableStatus"
              show-overflow-tooltip
              :label=allchange.startStop
            >
              <template slot-scope="scope">
              <span v-if="scope.row.enableStatus==0">
                {{ allchange.deactivate }}
              </span>
                <span v-else-if="scope.row.enableStatus==1">
                {{ allchange.enable }}
              </span>

              </template>
            </el-table-column>

            <el-table-column
              prop="onlineStatus"
              show-overflow-tooltip
              :label=allchange.online
            >
              <template slot-scope="scope">
              <span v-if="scope.row.onlineStatus==0">
                {{allchange.offline}}
              </span>
                <span v-else-if="scope.row.onlineStatus==1">
                {{allchange.online}}
              </span>

              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              width="220"
              show-overflow-tooltip
              :label=allchange.updateTime
            >
            </el-table-column>
            <el-table-column
              prop="updateTime"
              label="离线时间"
              show-overflow-tooltip
              width="180px"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.onlineStatus == 1">--</span>
                <span v-if="scope.row.onlineStatus == 0">{{ scope.row.offlineTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right" width="400"
              :label=allchange.operation

            >
              <template slot-scope="scope">

                <el-button type="text" size="small" @click="watcheqt(scope.row);">{{ allchange.viewDevice }}</el-button>
                <el-dropdown @command="handleCommand2" v-show="menusList.indexOf('DEVICE_OPERATION_CONTROL')!='-1'"
                >
  <span class="el-dropdown-link" style="font-size: 12px;">
    {{ allchange.Devicecontrol }}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{'label':'a','value':scope.row}">{{allchange.restart }}</el-dropdown-item>
                    <el-dropdown-item :command="{'label':'b','value':scope.row}">{{ allchange.breakbrake }}</el-dropdown-item>
                    <el-dropdown-item :command="{'label':'c','value':scope.row}">{{ allchange.closing }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="handleCommand" v-show="menusList.indexOf('DEVICE_OPERATION_GET_DATA')!='-1'">
  <span class="el-dropdown-link">
    {{ allchange.getdata }}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{'label':'a','value':scope.row}">{{ allchange.ObtainingRealtimeparameters }}</el-dropdown-item>
                    <el-dropdown-item :command="{'label':'d','value':scope.row}">{{ allchange.GetsfreezingParametersathour }}</el-dropdown-item>
                    <el-dropdown-item :command="{'label':'e','value':scope.row}">{{ allchange.GetsfreezingParametersatday }}</el-dropdown-item>
                    <el-dropdown-item :command="{'label':'f','value':scope.row}">{{ allchange.GetsfreezingParametersatmonth }}</el-dropdown-item>
<!--                    <el-dropdown-item :command="{'label':'c','value':scope.row}">{{  allchange.ObtainingDeviceParameters }}</el-dropdown-item>-->
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button type="text" size="small" @click="design(scope.row)" v-show="menusList.indexOf('DEVICE_OPERATION_SET_PARAM')!='-1'">{{ allchange.SetTheparameters }}</el-button>
                <el-button type="text" size="small" @click="lookcircuit(scope.row)">{{ allchange.viewCircle }}</el-button>
                <el-button @click="downloadData(scope.row)" v-if="scope.row.ismaster==true"  type="text" size="small">
                  {{ allchange.DownloadTheframe }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </div>
      <div style="float: right;margin-right: 40px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paginationTotal">
        </el-pagination>
      </div>
      <el-dialog :title=allchange.viewDevice :close-on-click-modal="false"  :visible.sync="adddmDialog" width="860px">
        <el-form ref="addLevelFormData" :rules="rules" :inline="true" :model="adddmform"  label-width="120px">
          <el-form-item :label=allchange.terminalName prop="terminalName">
            <el-input style="width: 280px;" v-model="adddmform.terminalName" disabled/>
          </el-form-item>
          <el-form-item :label=allchange.ProtocolType prop="protocol">
            <el-select style="width: 280px;"  v-model="adddmform.protocol" :placeholder=allchange.PleaseSelect disabled>
              <el-option
                key="1"
                label="mqtt"
                :value="1">
              </el-option>
              <el-option
                key="2"
                label="tcp"
                :value="2">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label=allchange.deviceImei prop="imei">
            <el-input style="width: 280px;" :disabled="maintitle=='查看主机' || maintitle=='Look at the host'" v-model="adddmform.imei" disabled />
          </el-form-item>
          <el-form-item :label=allchange.deviceModel prop="terminalTypeName">
            <el-select style="width: 280px;" filterable   v-model="adddmform.terminalTypeName" :placeholder=allchange.PleaseSelect disabled>
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label=allchange.AffiliatedUnit prop="deptNamelist">
            <el-cascader
              disabled
              style="width: 280px;"
              v-model="adddmform.deptNamelist"
              :show-all-levels="false"
              :options="DeptList"
              :props="{ expandTrigger: 'hover',value:'deptName',label:'deptName' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label=allchange.status prop="status1">
            <el-select style="width: 280px;"    v-model="adddmform.status1" :placeholder=allchange.PleaseSelect disabled>
              <el-option
                :label=allchange.unconnect
                :value="0">
              </el-option>
              <el-option
                :label=allchange.ConnectedOffline
                :value="1">
              </el-option>
              <el-option
                :label=allchange.ConnectionOnline
                :value="3">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label=allchange.simNumber  prop="sim">
            <el-input v-model="adddmform.sim" style="width: 280px;"  disabled />
          </el-form-item>
          <el-form-item :label=allchange.startStop prop="enableStatus">
            <el-switch
              disabled
              v-model="adddmform.enableStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-form>
          <div style="height: 300px;width: 100%;overflow: auto;">
            <el-table
              :cell-style="rowClass"
              :header-cell-style="headClass"
              ref="multipleTable"
              :data="parameter"
              :empty-text=allchange.nodata
              row-key="label"
              tooltip-effect="dark"
              style="width:100%;"

            >
              <el-table-column
                type="index"
                width="200"
                :label=allchange.Theserialnumber
              >

              </el-table-column>
              <el-table-column
                prop="label"
                :label=allchange.parameterName
              >

              </el-table-column>
              <el-table-column
                prop="value"
                :label=allchange.parameterValue
              >
              </el-table-column>
            </el-table>
          </div>


      </el-dialog>
      <el-dialog :title=allchange.Setthethreshold :close-on-click-modal="false"  :visible.sync="topdataDialog" width="450px">
        <el-form ref="topdataFormData" :rules="rules2"  :model="topdatamform"  label-width="110px">

          <el-form-item :label=allchange.Insulationaginglevel prop="insulationResistanceA">
            <el-input style="width: 280px;" v-model="topdatamform.insulationResistanceA"/>
          </el-form-item>
          <el-form-item :label=allchange.Insulationaginglevel2 prop="insulationResistanceA">
            <el-input style="width: 280px;" v-model="topdatamform.insulationResistanceB"/>
          </el-form-item>
          <el-form-item :label=allchange.Insulationaginglevel3 prop="insulationResistanceA">
            <el-input style="width: 280px;" v-model="topdatamform.insulationResistanceC"/>
          </el-form-item>
          <el-form-item :label=allchange.Electricalfirelevel1 prop="insulationResistanceA" style="margin-top: 20px;">
            <el-input style="width: 280px;" v-model="topdatamform.residualCurrentA"/>
          </el-form-item>
          <el-form-item :label=allchange.Electricalfirelevel2 prop="insulationResistanceA">
            <el-input style="width: 280px;" v-model="topdatamform.residualCurrentB"/>
          </el-form-item>
          <el-form-item :label=allchange.Electricalfirelevel3 prop="insulationResistanceA">
            <el-input style="width: 280px;" v-model="topdatamform.residualCurrentC"/>
          </el-form-item>
          <div style="text-align:right;" >
            <el-button type="primary" @click="uploadTopdata('topdataFormData')" >{{ allchange.save }}</el-button>
            <el-button @click="topdataDialog = false">{{ allchange.cancel }}</el-button>
          </div>
        </el-form>


      </el-dialog>
      <el-dialog :title=allchange.CheckCircuit :close-on-click-modal="false" :visible.sync="dialogVisible" width="650px">
        <el-table
          :data="cirdata"
          stripe
          style="width: 100%;">
          <el-table-column
            prop="branchName"
            :label=allchange.CircleName
          >
          </el-table-column>
          <el-table-column
            prop="simpleMess"
            :label=allchange.RunningState
          >
          </el-table-column>

          <el-table-column align="center"  :label=allchange.operation width="200px">
            <template slot-scope="scope">

              <span  class="dobtn" type="text" style="margin-left: 10px;" @click="showtopdata(scope.row)" v-show="menusList.indexOf('DEVICE_OPERATION_SET_THRESHOLD')!='-1'">{{ allchange.ThresholdConfiguration }}</span>

            </template>
          </el-table-column>
        </el-table>

      </el-dialog>
      <el-dialog :title=allchange.chooseTime :close-on-click-modal="false" :visible.sync="timeshow" width="450px">
        <div style="height: 60px;">
          <div style="padding-left: 16px">
            <el-date-picker
              v-if="sletime=='d'"
              v-model="time"
              value-format="yyyy-MM-dd HH"

              type="datetime"
              :placeholder=allchange.hour>
            </el-date-picker>
            <el-date-picker
              v-model="time"
              v-if="sletime=='f'"
              value-format="yyyy-MM"
              type="month"
              :placeholder=allchange.month>
            </el-date-picker>
            <el-date-picker
              v-model="time"
              v-if="sletime=='e'"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder=allchange.day>
            </el-date-picker>
          </div>

          <div style="float: right;margin-bottom: 16px;">
            <el-button type="primary" @click="sendforzedata()" >{{ allchange.save }}</el-button>
            <el-button @click="timeshow = false">{{ allchange.cancel }}</el-button>
          </div>
        </div>


      </el-dialog>

      <el-dialog :title=allchange.chooseTime :close-on-click-modal="false" :visible.sync="seletime" width="1300px">
        <div style="height: 500px;padding: 0 10px;">
          <div >

            <el-date-picker
              v-model="downTime"
              value-format="yyyy-MM-dd"
              type="date"
              size="large"
              :placeholder=allchange.selectDay>
            </el-date-picker>

              <el-button  @click="retimestart()"   style="margin:0 10px">{{ allchange.reset }}</el-button>


            <el-button type="primary" @click="uploadtime()" >{{ allchange.export }}</el-button>
            <el-button type="primary" @click="onrestart()" style="float: right;">刷新</el-button>
          </div>
          <div style="margin: 12px 0;height: 420px;overflow: auto;">
            <el-table
              v-loading="loading"
              :data="downtable"
              :empty-text=allchange.nodata
              stripe

              style="width: 100%;">
              <el-table-column
                prop="hostImei"
                :label=allchange.hostMachineimei
              >
              </el-table-column>
              <el-table-column
                prop="frame"
                :label=allchange.frameData
                width="320px"
              >
              </el-table-column>
              <el-table-column
                prop="protocol"
                :label=allchange.ProtocolType
              >
                <template slot-scope="scope">

                  <span >{{scope.row.protocol==1?'MQTT':'TCP'}}</span>

                </template>
              </el-table-column>
              <el-table-column
                prop="direction"
                :label=allchange.directionType
              >
                <template slot-scope="scope">

                  <span >{{scope.row.direction==1?'下发':'上传'}}</span>

                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                :label=allchange.updateTime
              >
              </el-table-column>

            </el-table>
          </div>
          <div style="float: right;">
            <el-pagination

              @current-change="handleCurrentChange2"
              background
              :current-page="currentPage2"

              :page-size="pageSize2"
              layout="total, prev, pager, next, jumper"
              :total="paginationTotal2">
            </el-pagination>
          </div>


        </div>


      </el-dialog>
      <el-dialog :title="congtitle" :close-on-click-modal="false" :visible.sync="adddmDialog2" width="450px">
        <el-form ref="addLevelFormData2" :rules="rules" :model="adddmform2"  label-width="120px">
          <el-form-item :label=allchange.terminalName prop="terminalName">
            <el-input :disabled="congtitle=='查看从机' || congtitle=='Look at the slave'" v-model="adddmform2.terminalName" />
          </el-form-item>

          <el-form-item :label=allchange.location prop="addr485">
            <el-input :disabled="congtitle=='查看从机' || congtitle=='Look at the slave'" v-model="adddmform2.addr485" />
          </el-form-item>
          <el-form-item :label=allchange.deviceImei prop="imei">
            <el-input :disabled="congtitle=='查看从机' || congtitle=='Look at the slave'" v-model="adddmform2.imei" />
          </el-form-item>
          <el-form-item :label=allchange.hostMachineimei prop="hostTerminalImei">
            <el-input :disabled="congtitle=='查看从机' || congtitle=='Look at the slave'" v-model="adddmform2.hostTerminalImei" />
          </el-form-item>
          <el-form-item :label=allchange.deviceModel prop="terminalTypeName">
            <el-select :disabled="congtitle=='查看从机' || congtitle=='Look at the slave'" style="width: 320px;" filterable v-model="adddmform2.terminalTypeName" :placeholder=allchange.PleaseSelect>
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label=allchange.AffiliatedUnit prop="deptNamelist">
            <el-cascader
              :disabled="congtitle=='查看从机' || congtitle=='Look at the slave'"
              style="width: 320px;"
              :show-all-levels="false"
              v-model="adddmform2.deptNamelist"
              :options="DeptList"
              :props="{value:'deptName',label:'deptName'}"
            ></el-cascader>
          </el-form-item>

          <el-form-item :label=allchange.startStop prop="status2">
            <el-switch
              :disabled="congtitle=='查看从机' || congtitle=='Look at the slave'"
              v-model="adddmform2.enableStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
          <div style="text-align:right;" v-show="congtitle!='查看从机' && congtitle!='Look at the slave'">

            <el-button @click="adddmDialog2 = false">{{ allchange.cancel }}</el-button>
          </div>
        </el-form>
      </el-dialog>
      <el-dialog :title=allchange.EditParameters :close-on-click-modal="false"  :visible.sync="changeparam" width="800px">

        <div style="width: 100%;overflow: auto;padding:10px;">


<!--          <el-table-->
<!--            :cell-style="rowClass"-->
<!--            :header-cell-style="headClass"-->
<!--            ref="multipleTable"-->
<!--            v-loading="isloading"-->
<!--            :data="parameter"-->
<!--            row-key="label"-->
<!--            :empty-text=allchange.nodata-->
<!--            tooltip-effect="dark"-->
<!--            style="width:100%;"-->

<!--          >-->
<!--            <el-table-column-->
<!--              type="index"-->
<!--              :label=allchange.Theserialnumber-->
<!--            >-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="label"-->
<!--              :label=allchange.parameterName-->
<!--            >-->

<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="value"-->
<!--              :label=allchange.parameterValue-->
<!--            >-->
<!--              <template slot-scope="scope">-->

<!--                <el-input-->
<!--                  v-if="scope.row.dataType!='date'"-->
<!--                  style="width: 220px;"-->
<!--                  v-model="scope.row.value">-->
<!--                </el-input>-->
<!--                <el-date-picker-->
<!--                  v-if="scope.row.dataType=='date'"-->
<!--                  v-model="scope.row.value"-->
<!--                  type="datetime"-->
<!--                  value-format="timestamp"-->
<!--                ></el-date-picker>-->
<!--              </template>-->
<!--            </el-table-column>-->


<!--          </el-table>-->

        </div>
        <changeDialog >

        </changeDialog>

      </el-dialog>
    </div>

  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Axios2 from "@/utils/Axios2";

import Vue from "vue";
import qs from "qs";
import axios3 from "axios";
import changefun from "../../../../lang/i18n";
import changeDialog from "./changeDialog";
import Bus from "@/utils/bus.js";
export default {
  name: "tabsContent1",
  mounted() {
    let that=this
    this.allchange={
      deviceModel:changefun("deviceModel"),
      reset:changefun("reset"),
      ThresholdConfiguration:changefun("ThresholdConfiguration"),
      location:changefun("location"),
      breakbrake:changefun("breakbrake"),
      closing:changefun("closing"),
      Devicecontrol:changefun("Devicecontrol"),
      export:changefun("export"),
      readParam:changefun("readParam"),
      selectDay:changefun("selectDay"),
      PleaseSelect:changefun("PleaseSelect"),
      enableState:changefun("enableState"),
      all:changefun("all"),
      enable:changefun("enable"),
      deactivate:changefun("deactivate"),
      connectState:changefun("connectState"),
      onlineState:changefun("onlineState"),
      online:changefun("online"),
      offline:changefun("offline"),
      deviceName:changefun("deviceName"),
      inputDevicename:changefun("inputDevicename"),
      deviceImei:changefun("deviceImei"),
      inputdeviceImei:changefun("inputdeviceImei"),
      EditParameters:changefun("EditParameters"),
      directionType:changefun("directionType"),
      frameData:changefun("frameData"),
      query:changefun("query"),
      loading:changefun("loading"),
      addHost:changefun("addHost"),
      batchDelete:changefun("batchDelete"),
      batchGeneration:changefun("batchGeneration"),
      onlineDevice:changefun("onlineDevice"),
      offlineDevice:changefun("offlineDevice"),
      UploadHost:changefun("UploadHost"),
      downloadHosttemplate:changefun("downloadHosttemplate"),
      uploadSlave:changefun("uploadSlave"),
      downloadSlavetemplate:changefun("downloadSlavetemplate"),
      circusNumber:changefun("circusNumber"),
      circusModel:changefun("circusModel"),
      AffiliatedUnit:changefun("AffiliatedUnit"),
      position:changefun("position"),
      DeviceID:changefun("DeviceID"),
      ManuallyAdd:changefun("ManuallyAdd"),
      DownloadTheframe:changefun("DownloadTheframe"),
      SetTheparameters:changefun("SetTheparameters"),
      determine:changefun("determine"),
      ConnectedOffline:changefun("ConnectedOffline"),
      ConnectionOnline:changefun("ConnectionOnline"),
      Theserialnumber:changefun("Theserialnumber"),
      parameterName:changefun("parameterName"),
      parameterValue:changefun("parameterValue"),
      Insulationaginglevel:changefun("Insulationaginglevel"),
      Insulationaginglevel2:changefun("Insulationaginglevel2"),
      Insulationaginglevel3:changefun("Insulationaginglevel3"),
      Electricalfirelevel1:changefun("Electricalfirelevel1"),
      Electricalfirelevel2:changefun("Electricalfirelevel2"),
      Electricalfirelevel3:changefun("Electricalfirelevel3"),
      RunningState:changefun("RunningState"),
      chooseTime:changefun("chooseTime"),
      hour:changefun("hour"),
      month:changefun("month"),
      day:changefun("day"),
      hostMachineimei:changefun("hostMachineimei"),
      nodata:changefun("nodata"),
      Lookhost:changefun("Lookhost"),

      startStop:changefun("startStop"),
      connectStatus:changefun("connectStatus"),
      unconnect:changefun("unconnect"),
      connected:changefun("connected"),
      ProtocolType:changefun("ProtocolType"),
      updateTime:changefun("updateTime"),
      operation:changefun("operation"),
      viewDevice:changefun("viewDevice"),
      viewCircle:changefun("viewCircle"),
      externalDevices:changefun("externalDevices"),
      edit:changefun("edit"),
      delete:changefun("delete"),
      addSlave:changefun("addSlave"),
      giveAddress:changefun("giveAddress"),
      simNumber:changefun("simNumber"),
      remark:changefun("remark"),
      uploadImage:changefun("uploadImage"),
      cancel:changefun("cancel"),
      save:changefun("save"),
      communicationAddress:changefun("communicationAddress"),
      terminalName:changefun("terminalName"),
      status:changefun("status"),
      normal:changefun("normal"),
      malfunction:changefun("malfunction"),
      tableDetail:changefun("tableDetail"),
      EditCircle:changefun("EditCircle"),
      CircleName:changefun("CircleName"),
      SelectMonitoring:changefun("SelectMonitoring"),
      AddMonitoring:changefun("AddMonitoring"),
      MassProduction:changefun("MassProduction"),
      restart:changefun("restart"),
      getdata:changefun("getdata"),
      ObtainingRealtimeparameters:changefun("ObtainingRealtimeparameters"),
      GetsfreezingParametersathour:changefun("GetsfreezingParametersathour"),
      GetsfreezingParametersatday:changefun("GetsfreezingParametersatday"),
      GetsfreezingParametersatmonth:changefun("GetsfreezingParametersatmonth"),
      ObtainingDeviceParameters:changefun("ObtainingDeviceParameters"),
      timeirst:changefun("timeirst"),
      Uploadedsuccessfully:changefun("Uploadedsuccessfully"),
      Uploadfailed:changefun("Uploadfailed"),
      Modifysuccess:changefun("Modifysuccess"),
      Sendingsucceeded:changefun("Sendingsucceeded"),
      Failedsend:changefun("Failedsend"),
      Sendingquerysucceeded:changefun("Sendingquerysucceeded"),
      querysuccessful:changefun("querysuccessful"),
      Sendingrequestsucceeded:changefun("Sendingrequestsucceeded"),

    }
    this.menusList=Vue.prototype.menusList
    Bus.$on("colseupload", (val) => {
      that.changeparam = false
    });
    this.queryTree()
    this.queryTypes()
    this.getTableData()
    this.getpramData()
    this.initWebSocket()
    this.getnowtime()

  },
  data() {
    return {
      allchange:{
        parameterValue:"",
        readParam:"",
        reset:"",
        ThresholdConfiguration:"",
        Devicecontrol:"",
        breakbrake:"",
        Lookhost:"",
        closing:"",
        determine:"",
        Uploadedsuccessfully:"",
        Uploadfailed:"",
        Sendingsucceeded:"",
        Sendingquerysucceeded:"",
        querysuccessful:"",
        Sendingrequestsucceeded:"",
        Failedsend:"",
        Modifysuccess:"",
        timeirst:"",
        location:"",
        selectDay:"",
        frameData:"",
        export:"",
        hostMachineimei:"",
        directionType:"",
        EditParameters:"",
        Insulationaginglevel:"",
        Insulationaginglevel2:"",
        Insulationaginglevel3:"",
        Electricalfirelevel1:"",
        Electricalfirelevel2:"",
        Electricalfirelevel3:"",
        RunningState:"",
        chooseTime:"",
        nodata:"",
        operation:"",
        viewCircle:"",
        viewDevice:"",
        ConnectedOffline:"",
        restart:"",
        getdata:"",
        ObtainingRealtimeparameters:"",
        GetsfreezingParametersathour:"",
        GetsfreezingParametersatday:"",
        GetsfreezingParametersatmonth:"",
        SetTheparameters:"",
        ObtainingDeviceParameters:"",
        addSlave:"",
        SelectMonitoring:"",
        MassProduction:"",
        AddMonitoring:"",
        simNumber:"",
        remark:"",
        uploadImage:"",
        status:"",
        ConnectionOnline:"",
        tableDetail:"",
        EditCircle:"",
        ManuallyAdd:"",
        cancel:"",
        save:"",
        terminalName:"",
        communicationAddress:"",
        giveAddress:"",
        edit:"",
        delete:"",
        externalDevices:"",
        DeviceID:"",
        updateTime:"",
        deviceModel:"",
        PleaseSelect:"",
        DownloadTheframe:"",
        enableState:"",
        all:"",
        enable:"",
        deactivate:"",
        onlineState:"",
        connectState:"",
        online:"",
        offline:"",
        deviceName:"",
        inputDevicename:"",
        deviceImei:"",
        inputdeviceImei:"",
        query:"",
        loading:"",
        addHost:"",
        batchDelete:"",
        batchGeneration:"",
        onlineDevice:"",
        offlineDevice:"",
        UploadHost:"",
        downloadHosttemplate:"",
        uploadSlave:"",
        downloadSlavetemplate:"",
        circusNumber:"",
        circusModel:"",
        AffiliatedUnit:"",
        position:"",
        startStop:"",
        connectStatus:"",
        unconnect:"",
        connected:"",
        ProtocolType:"",
        normal:"",
        malfunction:"",
        CircleName:"",
      },
      treeData: [],
      menusList: [],
      starttime:"",
      nowterminalId:"",
      isloading:false,
      enableOption: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "启用",
          value: 1,
        },
        {
          label: "停用",
          value: 0,
        },
      ],
      connectOption: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已连接",
          value: 1,
        },
        {
          label: "未连接",
          value: 0,
        },
      ],
      onlineOption: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "在线",
          value: 1,
        },
        {
          label: "离线",
          value: 0,
        },
      ],
      defaultProps: {
        children: "children",
        label: "deptName",
      },
      deviceOption: [{ label: "全部", value: "" }],
      loading:true,
      part:"",
      eqName:"",
      list:[{
        label:"111",
        value:"111"
      }],
      downTime:"",
      seletime:false,
      parmdata:[],
      enableStatus:"",
      connectStatus:"",
      onlineStatus:"",
      terminalName:"",
      deptName:"",
      terminalTypeName:"",
      statusList:[],
      searchstatusList:[],
      typeList:[],
      searchtypeList:[],
      DeptList:[],
      pageSize:10,
      pageSize2:10,
      time:null,
      page:1,
      page2:1,
      currentPage:1,
      currentPage2:1,
      paginationTotal:100,
      paginationTotal2:100,
      adddmDialog:false,
      adddmDialog2:false,
      dialogVisible:false,
      timeshow:false,
      sttm:null,
      edtm:null,
      userName:"",
      parentprotocol:null,
      maintitle:"",
      congtitle:"",
      cirdata:[],
      nowscop: {
        ismaster:false
      },
      tableData:[{

      }],
      adddmform:{
    "status2":4
      },
      adddmform2:{

      },
      partlist:[
        {

        }
      ],
      rules: {

      },
      rules2:{
        insulationResistanceA: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        insulationResistanceB: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        insulationResistanceC: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        residualCurrentA: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        residualCurrentB: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        residualCurrentC: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],

      },
      topdatamform:{},
      topdataDialog:false,
      nowbranchId:null,
      sletime:"",
      nowbranchdata:{},
      parameter:[],
      imei:"",
      changeparam:false,
      alljsondata:{},
      nowequmentdata:"",
      nowimei:null,
      deptId:null,
      rowdata:null,
      downtable:[],
    };
  },

  destroyed () {

  },
  methods: {

    sendparams(){

      // this.getlongparam(this.rowdata)

        Bus.$emit('resend','1')

    },
    retimestart(){
      this.downTime=this.starttime
    },
    refresh() {
      this.imei = "";
      this.deptId = "";
      this.deptName = "";
      this.enableStatus = "";
      this.connectStatus = "";
      this.onlineStatus = "";
      this.terminalName = "";
      this.terminalTypeName = "";
      this.getTableData();
    },
    handleNodeClick(data) {
      this.deptId = data.deptId;
      this.getTableData();
    },
    queryTree() {
      let param = {};
      param.method = "get";
      param.url = "/dept/getDeptTree";
      param.params = {};
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.treeData = [];
          this.deptdata=res.data
          this.treeData.push(res.data[0]);

          // this.setName(this.treeData);
        }
      });
    },
    queryTypes() {
      Axios.ajax({
        method: "post",
        url: "/device/typeAlias",
      }).then((res) => {
        if (res.data) {

          for (let i = 0; i < res.data.length; i++) {
            this.deviceOption.push({
              label: res.data[i].typeAlias,
              value: (res.data[i].typeCodes).toString(),
            });
          }
        }
      });
    },
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date


      this.starttime = time;
      this.downTime = time;
    },
     getNextDay(d) {
  d = new Date(d) ;
  d = +d + 1000 * 60 * 60 * 24;
  d = new Date(d);

  var yy = d.getFullYear();
  var mm = d.getMonth() + 1;
  var dd = d.getDate();
  var nextday = yy + "-";
  if (mm < 10) {
    nextday += "0"
  }
  nextday += mm + "-";
  if (dd < 10) {
    nextday += "0"
  }
  nextday += dd;
  return nextday;
},
  uploadtime(){

    let that = this;
    let param = {};
    param.method="get";
    param.url="device/exportCommData";
    if(this.downTime==""){
      this.$message({
        type: 'error',
        message: this.allchange.timeirst
      });
      return
    }

    param.params={
      "endDate":this.getNextDay(this.downTime),
      "hostImei":this.nowimei,
      // "hostImei":"0000000144Q0004",
      "startDate":this.downTime

    }
    axios3({
      methods: 'get',
      url: this.baseUrl+param.url,
      params:param.params,
      responseType: 'blob'
    }).then((res)=>{

      const aLink = document.createElement("a");

      let blob = new Blob([res.data], {type: "application/vnd.ms-excel;charset=utf-8"})

      aLink.href = URL.createObjectURL(blob)

      aLink.download = this.nowimei+'.xls'

      aLink.click()

      document.body.appendChild(aLink)



    })
    },
    downloadData(data){
    this.seletime=true
    this.nowimei=data.imei
      this.gettimeData()
    },
    onrestart(){
      this.currentPage2=1
      this.gettimeData()
    },
    gettimeData(){

      if(this.downTime==""){
        this.$message({
          type: 'error',
          message: this.allchange.timeirst
        });
        return
      }
      this.loading=true
      let that = this;
      let param = {};
      param.method="get";
      param.url="/device/CommData";
      param.params={
        "endDate":this.getNextDay(this.downTime),
        "hostImei":this.nowimei,
        // "hostImei":"0000000144Q0004",
        "startDate":this.downTime,
        "pageNum":this.currentPage2,
        "showNum":this.pageSize,

      }
      Axios.ajax(param).then((res)=>{
        this.loading=false
        if(res.data){
          this.downtable=res.data.dataList
          this.paginationTotal2=res.data.totalNum
        }

      })
    },
    //重置所有参数数据
    cancelChange(){
      this.changeparam = false
      this.parameter=[]
      this.alljsondata={}
    },
    //修改参数
    uploadParams(data){

      for(let i=0;i<this.parameter.length;i++){
        for(let j=0;j<this.alljsondata.values.length;j++){
          if(this.parameter[i].label==this.alljsondata.values[j].description){
            this.alljsondata.values[j].value=this.parameter[i].value
          }
        }
      }

      let that = this;
      let param = {};


      param.method="post";

      param.url="/device/msg/set/parameter";
      param.data=
        {
          address:this.nowequmentdata.addr485,
          param:this.alljsondata,
          topic:this.nowequmentdata.hostTerminalImei,
        }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          this.$message({
            type: 'success',
            message: this.allchange.Uploadedsuccessfully
          });
          this.parameter=[]
          this.changeparam=false
          this.alljsondata={}
        }else{
          this.$message({
            type: 'error',
            message: res.resultMessage
          });
        }

      })
    },
    //编辑阈值
    uploadTopdata(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {

          let that = this;
          let param = {};
          let userId = ""
          param.method = "post";
          param.url = "/branch/modifyThreshold";
          this.topdatamform.branchId=this.nowbranchId
          param.data = this.topdatamform
          Axios.ajax(param).then((res) => {

            if (res.resultCode == '0') {
              this.$message({
                type: 'success',
                message:this.allchange.Modifysuccess
              });
              this.topdataDialog = false
              this.topdatamform = {}

            } else {
              this.$message({
                type: 'error',
                message: res.msg
              });
            }

          })
        } else {

          return false;
        }
      });

    },

    //配置阈值
    showtopdata(data){
      let that = this;
      this.nowbranchId=data.branchId
      let param = {};
      param.method="post";
      param.url="/branch/threshold/"+data.branchId;
      param.data=qs.stringify({
        "branchId":data.branchId,
      })
      Axios.ajax(param).then((res)=>{

        if(res.data){

          this.topdatamform=res.data
          this.topdataDialog=true
        }

      })

    },
    // 初始化一个 websocket 对象，同时给基本属性赋值
    initWebSocket: function () {
      var token=sessionStorage.getItem('token')

      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https，此处传入需要跟后台连接的接口路径
      this.websock = new WebSocket("wss://www.wha518.com/frontEndQuery?authorization="+ token);//测试服
      //this.websock = new WebSocket("ws://124.70.202.197/frontEndQuery?authorization="+ token);//正式服
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      // this.websock.onclose = this.websocketclose;
    },
    // 定义 websocket open属性的函数
    websocketonopen: function () {

      // this.websock.send(token)
      console.log('WebSocket连接成功');
    },
    // 定义 websocket onerror属性的函数
    websocketonerror: function (e) {
      console.log('WebSocket连接发生错误');
    },
    // 定义 websocket onmessage属性的函数
    websocketonmessage: function (e) {

      let mess=e.data
      let messsdata=JSON.parse(mess)

      if(messsdata.type=='004'){
        if(messsdata.storage.result=='重启成功'){
          this.$message({
            type: 'success',
            message: '重启成功!'
          });
        }else{
          this.$message({
            type: 'error',
            message: "重启失败"
          });
        }

      }
      if(messsdata.opCode=='06'){
        this.$message({
          type: 'success',
          message: '冻结数据上报成功!'
        });

      }else if(messsdata.opCode=='01'){
        this.$message({
          type: 'success',
          message: '实时数据上报成功!'
        });
      }else if(messsdata.opCode=='08'){
        this.$message({
          type: 'success',
          message: '参数查看成功!'
        });
      }else if(messsdata.opCode=='00'){
        this.$message({
          type: 'success',
          message: '参数设置成功!'
        });
      }else if(messsdata.opCode=='01'){
        this.$message({
          type: 'success',
          message: '下发成功!'
        });
      }
      // this.messageList.push(e.data);
    },
    // 定义 websocket onclose属性的函数
    websocketclose: function (e) {
      console.log('connection closed');
    },

    handlecirCommand(command){

    },

    handleCommand(command){


      if(command.label=='c'){
        this.getlongparam(command.value)
      }else if(command.label=='a'){
        this.getnow(command.value)
      }else {
        this.time=""
        this.nowbranchdata={}
          this.timeshow=true
        this.nowbranchdata=command.value
        this.sendForze(command.label)
      }
    },
    handleCommand2(command){


      if(command.label=='c'){
        this.sendclose(command.value)
      }else if(command.label=='a'){
        this.restart(command.value)
      }else if(command.label=='b'){
      this.sendopen(command.value)
      }
    },
    //发送合闸命令
    sendclose(data){


      let that = this;
      let param = {};
      param.method="post";
      param.url="/device/msg/switch/close";
      param.data=
     {
          terminalId:data.terminalId,
        }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          this.$message({
            type: 'success',
            message: this.allchange.querysuccessful
          });

        }else{
          this.$message({
            type: 'error',
            message: res.msg
          });
        }

      })
    },
    //发送分闸命令
    sendopen(data){

      let that = this;
      let param = {};
      param.method="post";
      param.url="/device/msg/switch/open";
      param.data=
       {
          terminalId:data.terminalId,
        }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          this.$message({
            type: 'success',
            message: this.allchange.querysuccessful
          });

        }else{
          this.$message({
            type: 'error',
            message: res.msg
          });
        }

      })
    },
    sendForze(data){
      this.sletime=data
    },
    getlongparam(data){
      let that = this;
      let param = {};
      this.nowequmentdata=data
      this.alljsondata={}
      param.method="post";
      param.url="/device/msg/query/parameterRemote";

      param.data=
        {
          terminalId:data.terminalId,


        }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          this.$message({
            type: 'success',
            message: this.allchange.Sendingsucceeded
          });
          this.isloading=true
          setTimeout(function(){
            // that.getparam(data)
            that.isloading=false

          },10000)
        }else{

          this.$message({
            type: 'error',
            message: res.resultMessage
          });
        }

      })
    },
    sendforzedata(){

      let address=this.nowbranchdata.addr485
      let topic=this.nowbranchdata.hostTerminalImei
      let year=this.time.slice(0,4)
      let month=this.time.slice(5,7)
      let day=this.time.slice(8,10)
      let hour=this.time.slice(11,13)
      if(year){
        let that = this;
        let param = {};
        param.method="post";
        if(this.sletime=='d'){
          param.url="/msg/query/frozen/hour";
        }else if(this.sletime=='e'){
          param.url="/msg/query/frozen/day";
        }else if(this.sletime=='f'){
          param.url="/msg/query/frozen/month";
        }

        param.data=
          {
            address:address,
            topic:topic,
            year:year,
            month:month,
            day:day,
            hour:hour,
          }
        Axios2.ajax(param).then((res)=>{

          if(res.resultCode=='0'){
            this.$message({
              type: 'success',
              message: this.allchange.Sendingquerysucceeded
            });
            this.timeshow=false
          }else{
            this.$message({
              type: 'error',
              message: res.resultMessage
            });
          }

        })
      }else{
        this.$alert(this.allchange.timeirst);
      }



    },
    //获得实时数据
    getnow(data){

      let that = this;
      let param = {};
      param.method="post";
      param.url="/msg/query/realtime";
      param.data=
        {
          address:data.addr485,
          topic:data.hostTerminalImei,
        }
      Axios2.ajax(param).then((res)=>{

        if(res.status=='200'){
          this.$message({
            type: 'success',
            message: this.allchange.querysuccessful
          });
          this.getTableData()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          });
        }

      })
    },

    //获得参数
    getparam(data){

      let that = this;
      let param = {};
      this.nowequmentdata=data
      this.alljsondata={}
      this.parameter=[]

      param.method="post";
      param.url="/device/msg/query/parameterDB";

      param.data=
        {
          terminalId:data.terminalId,
        }
      Axios.ajax(param).then((res)=>{
        this.parameter=[]
        if(res.resultCode=='0'){
          // this.$message({
          //   type: 'success',
          //   message: this.allchange.querysuccessful
          // });
          if(res.data){
            let messsdata=JSON.parse(res.data)

            this.alljsondata={
              num:messsdata.num,
              startAddress:messsdata.startAddress,
              values:[]
            }
            for(let key in messsdata.values){
              this.parameter.push({
                label:messsdata.values[key].description,
                dataType:messsdata.values[key].dataType,
                value:messsdata.values[key].value,
                keyword:messsdata.values[key].parameterName,
              })
              this.alljsondata.values.push(messsdata.values[key])

            }
          }else{

            this.$message({
              type: 'error',
              message:"当前设备无数据"
            });
          }


        }else{

          this.$message({
            type: 'error',
            message:res.resultMessage
          });
        }

      })
    },
    // 表头样式设置
    headClass () {
      return 'text-align: center;background:rgb(242,242,242);color:rgb(140,138,140)'
    },
    // 表格样式设置
    rowClass () {
      return 'text-align: center;'
    },
    todetail(data){
      sessionStorage.setItem("branchId", data.branchId);
      sessionStorage.setItem("terminalTypeName", data.terminalTypeName);
      sessionStorage.setItem("imei", data.imei);
      this.$router.push("/numCenterPage/forzedata");

    },
    restart(data){
      let that = this;
      let param = {};


      param.method="post";
      param.url="/msg/reboot";
      param.data=
        {
          address:data.addr485,

          topic:data.hostTerminalImei,
        }
      Axios.ajax(param).then((res)=>{

        if(res.status=='200'){
          this.$message({
            type: 'success',
            message: this.allchange.Sendingrequestsucceeded
          });
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          });
        }

      })
    },
    lookcircuit(data){

      let that = this;
      let param = {};
      param.method="get";
      param.url="/branch/query";
      param.params={
        "terminalId":data.terminalId,
      }
      Axios.ajax(param).then((res)=>{

        if(res.data){
        that.cirdata=res.data
        that.dialogVisible=true

        }

      })
    },
    handleClick(data){
      this.adddmform2={}

        let that=this
      this.adddmDialog2=true
      this.congtitle=this.allchange.addSlave
      that.adddmform2.hostTerminalImei=data.imei
      that.parentprotocol=data.protocol
    },
    getpramData(){
      let that = this;

      let param2 = {};
      let param3 = {};

      param2.method="get";
      param2.url="/device/types";
      param2.params={

      }
      Axios.ajax(param2).then((res)=>{

        if(res.data){
          for(let i=0;i<res.data.length;i++){
            this.typeList.push({
              label:res.data[i].terminal_type_name,
              value:res.data[i].terminal_type_name,
            })
            this.searchtypeList.push({
              label:res.data[i].terminal_type_name,
              value:res.data[i].terminal_type_name,
            })
          }
          this.searchtypeList.unshift({
            label:this.allchange.all,
            value:"",
          })
        }

      })
      param3.method="get";
      param3.url="/dept/getDeptTree";
      param3.params={

      }
      Axios.ajax(param3).then((res)=>{

        if(res.data){
          that.DeptList=res.data
        }

      })
    },

    // 每页显示条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getTableData()
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    // 当前页数
    handleCurrentChange2(val) {
      this.currentPage2 = val
      this.gettimeData()
    },
    getTableData(){
      let that = this;
      let param = {};
      let deptName=""
      if(this.deptName){
        deptName=this.deptName[this.deptName.length - 1]
      }


      param.method="post";
      param.url="/device/queryAll";
      param.data=qs.stringify({
        pageNum: this.currentPage,
        showNum: this.sizePage,
        deptId: this.deptId,
        imei: this.imei,
        enableStatus: this.enableStatus,
        connectStatus: this.connectStatus,
        onlineStatus: this.onlineStatus,
        terminalName: this.terminalName ? this.terminalName : null,
        typeCodes: this.terminalTypeName ? (this.terminalTypeName).split(",") : null,
        // terminalTypeName:['0d'],
      })
      Axios.ajax(param).then((res)=>{

        if(res.data){
          that.tableData=[]
          for(let i=0;i<res.data.dataList.length;i++){
            res.data.dataList[i].host.children=[]
            res.data.dataList[i].host.ismaster=true

            for(let j=0;j<res.data.dataList[i].sub.length;j++){
              res.data.dataList[i].sub[j].ismaster=false

              res.data.dataList[i].host.children.push(res.data.dataList[i].sub[j])

            }
            that.tableData.push(res.data.dataList[i].host)

          }
          that.paginationTotal=res.data.totalNum

        }

      })
    },
    handleSelectionChange(data){

    },
    afteropen(){


    },
    design(data){
      // this.getparam(data)
      this.rowdata=data

    let that=this
      this.changeparam=true
      this.nowterminalId=data.terminalId
      setTimeout(function(){
        Bus.$emit('changeterminalId',data.terminalId)
      },50)




    },


    changestart(row){

    },

    watcheqt(data){
      if(data.ismaster==true){
        this.adddmDialog=true
        this.maintitle=this.allchange.Lookhost
        this.adddmform=data
        this.adddmform.deptNamelist=data.deptName
        this.adddmform.hostTerminalImei=data.imei
      }else{
        this.adddmDialog2=true
        this.congtitle=this.allchange.Lookslave
        this.adddmform2=data
        this.adddmform2.deptNamelist=data.deptName
      }
      this.getparam(data)
    },
  },
  watch: {
    terminalTypeName(){
      this.getTableData()
    },
    enableStatus(){
      this.getTableData()
    },
    connectStatus(){
      this.getTableData()
    },
    onlineStatus(){
      this.getTableData()
    },
    terminalName(){
      this.getTableData()
    },
    imei(){
      this.getTableData()
    },
    downTime(){
      this.gettimeData()
    }
  },
  components: {changeDialog}
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.tabsContent{
  height: 100%;
}
.tree-Table {
  padding-top: 50px;
  display: flex;
  justify-content: space-between;
  .tree {
    width: 320px;
    height: 620px;
    overflow-y: auto;
  }
  .tableList {
    width: calc(100% - 350px);
    height: 620px;
    padding-right: 48px;
    overflow: auto;
  }
}
.top-title{
  font-size: 16px;
  height: 57px;
  line-height: 57px;
  padding-left: 36px;
  border-bottom:2px solid rgba(0, 0, 0, 0.04);

}
.search-btncav {
  position: absolute;
  top: 2px;
  right: -50px;
  cursor: pointer;
}

.tbcav{

  width: 470px;
  height: 350px;

  background-repeat: no-repeat;
  background-position: 358px 59px;
  background-size: 79px 200px;
}
.loading-con{
  width: 94%;
  margin: 0 auto;
  height:100%;
  z-index: 100;
  background-color: rgba(0,0,0,0.5);
  text-align: center;
  img{
    margin: 0 auto;
    vertical-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
  }
}
.search-blank{

  padding-left: 20px;

  border-top: 1px solid #ddd;
  padding-top: 8px;
}
.bc-sp{
  margin-left: 20px;
}
.search-btn{
  display: inline-block;
  width: 56px;
  height: 28px;
  text-align: center;
  background-color: #5780fa;
  color: #fff;
  line-height: 28px;
  margin-left: 20px;
  border-radius: 4px;
  cursor: pointer;
  float: right;
  margin-right: 40px;
  position: relative;
  top: 10px;
}
.main-title{
  height: 46px;
  border-bottom: 1px solid #ddd;
  line-height: 46px;
  font-size: 24px;
  text-align: center;
}

.main-con{
  height: calc(100% - 120px);
  position: relative;
  overflow: hidden;
  .btn-list{
    height: 60px;
    padding: 10px 20px;
  }
  .btn-blue{
    display: inline-block;
    border-radius: 4px;
    cursor: pointer;
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
    margin-left: 16px;
    background-color: #5780fa;
    color: #fff;

  }
}
.query {
  padding:36px 36px 0 36px;
  height: 60px;

  display: flex;
  justify-content: space-between;
  font-size: 16px;
  .font {
    margin: 0 12px 0 20px;
  }
  .font:nth-child(1) {
    margin-left: 0px;
  }
}

.action {
  display: flex;
  position: relative;
  p {
    font-size: 14px;
    color: #252b3c;
    font-weight: normal;
  }
  .export {
    position: absolute;
    left: 263px;
  }
  .btnGroup {
    position: absolute;
    right: 0;
  }
}

.main-table{
  width: 96%;
  height: calc(100% - 100px);
  margin: 20px auto;
  overflow: auto;
}
.dobtn{
  width: 80px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  display: inline-block;
  background-color:#409eff ;
  border-color: #409eff;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
}
@media screen and (min-width: 320px) and (max-width: 1700px){
  .search-blank{
    height: 120px;
    padding-left: 20px;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    padding-top: 8px;
  }
 .main-con {

    margin-bottom: 20px;
    .query {
      height: 110px;
      display: flex;
      justify-content: space-between;
      font-size: 16px;

    }
  }
}



</style>
<style lang="less">
//#app .el-form-item{
//  margin-bottom: 12px;
//}
#app .tabsContent .el-pagination.is-background .el-pager li:not(.disabled).active{
  color: #fff;
}
//.el-button {
//  color: #5780FA !important;
//}
#app .tabsContent .el-dropdown .el-dropdown-link{
  font-size: 12px;
}
</style>
